// extracted by mini-css-extract-plugin
export default {"box":"index_box_VicnU","title":"index_title_bGLhO","play_btn":"index_play_btn_gCgIS"};